import { library } from '@fortawesome/fontawesome-svg-core'
// light
import { faCircle as falCircle } from '@fortawesome/pro-light-svg-icons/faCircle'
import { faSquare as falSquare } from '@fortawesome/pro-light-svg-icons/faSquare'
import { faXmark as falXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
// solid
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faSquareCheck as fasSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(falCircle)
library.add(falSquare)
library.add(falXmark)

library.add(fasCircle)
library.add(fasSquareCheck)

export default FontAwesomeIcon

export const ART = {
  fal: 'light',
  fas: 'solid',
}
